var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridViewIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.5C0.834375 0.5 0.5 0.834375 0.5 1.25V2.75C0.5 3.16563 0.834375 3.5 1.25 3.5H2.75C3.16563 3.5 3.5 3.16563 3.5 2.75V1.25C3.5 0.834375 3.16563 0.5 2.75 0.5H1.25ZM6 1C5.44688 1 5 1.44687 5 2C5 2.55312 5.44688 3 6 3H15C15.5531 3 16 2.55312 16 2C16 1.44687 15.5531 1 15 1H6ZM6 6C5.44688 6 5 6.44688 5 7C5 7.55312 5.44688 8 6 8H15C15.5531 8 16 7.55312 16 7C16 6.44688 15.5531 6 15 6H6ZM6 11C5.44688 11 5 11.4469 5 12C5 12.5531 5.44688 13 6 13H15C15.5531 13 16 12.5531 16 12C16 11.4469 15.5531 11 15 11H6ZM0.5 6.25V7.75C0.5 8.16563 0.834375 8.5 1.25 8.5H2.75C3.16563 8.5 3.5 8.16563 3.5 7.75V6.25C3.5 5.83437 3.16563 5.5 2.75 5.5H1.25C0.834375 5.5 0.5 5.83437 0.5 6.25ZM1.25 10.5C0.834375 10.5 0.5 10.8344 0.5 11.25V12.75C0.5 13.1656 0.834375 13.5 1.25 13.5H2.75C3.16563 13.5 3.5 13.1656 3.5 12.75V11.25C3.5 10.8344 3.16563 10.5 2.75 10.5H1.25Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewIconActive);
export default __webpack_public_path__ + "static/media/gridViewIconActive.fd693b7390ed69c813003a25db9e052f.svg";
export { ForwardRef as ReactComponent };